import { Typography, Cushion } from '@pitchero/react-ui';
import React from 'react';
import { Trans } from '../../lib/i18n';

const ImportantFacts = () => (
  <>
    <Cushion style={{ fontSize: 24 }} component="div">
      <Typography
        style={{
          paddingBottom: 15,
          color: '#0B375D',
          fontSize: 24,
          fontWeight: 'bold',
        }}
      >
        <strong>
          <Trans i18nKey="fundraisingClub:important_facts" />
        </strong>
      </Typography>

      <Typography
        component="div"
        preset="body--large"
        color="black"
        style={{
          paddingTop: 15,
          paddingBottom: 15,
        }}
      >
        <Trans
          i18nKey="fundraisingClub:facts_contact"
          components={{
            a: (
              <a
                style={{ color: '#3091DB' }}
                href="mailto:thefundraisingclub@contactourlottery.org.uk"
              >
                thefundraisingclub@contactourlottery.org.uk
              </a>
            ),
          }}
        />
      </Typography>

      <Typography
        component="p"
        preset="body--large"
        color="black"
        style={{ paddingBottom: 15, wordBreak: 'auto-phrase' }}
      >
        <li>
          <Trans i18nKey="fundraisingClub:facts_1" />
        </li>
        <li>
          <Trans
            i18nKey="fundraisingClub:facts_2"
            components={{
              terms: (
                <a
                  href="https://thefundraisinglottery.joinourlottery.org.uk/terms-and-conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'inline-block', color: '#3091DB' }}
                >
                  Terms and Conditions
                </a>
              ),
              complaints: (
                <a
                  href="https://thefundraisinglottery.joinourlottery.org.uk/complaints-and-disputes"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'inline-block', color: '#3091DB' }}
                >
                  Complaints and Dispute Policy
                </a>
              ),
              privacy: (
                <a
                  href="https://thefundraisinglottery.joinourlottery.org.uk/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'inline-block', color: '#3091DB' }}
                >
                  Privacy Policy
                </a>
              ),
              faq: (
                <a
                  href="https://thefundraisinglottery.joinourlottery.org.uk/faq"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'inline-block', color: '#3091DB' }}
                >
                  FAQ
                </a>
              ),
            }}
          />
        </li>
        <li>
          <Trans
            i18nKey="fundraisingClub:facts_3"
            components={{
              a: (
                <a
                  href="https://www.gamblock.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'inline-block', color: '#3091DB' }}
                >
                  www.gamblock.com
                </a>
              ),
            }}
          />
        </li>
        <li>
          <Trans
            i18nKey="fundraisingClub:facts_4"
            components={{
              a: (
                <a
                  href="https://thefundraisinglottery.joinourlottery.org.uk/assets/Self%20Exclusion%20Form%20BeeSMART.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'inline-block', color: '#3091DB' }}
                >
                  here
                </a>
              ),
            }}
          />
        </li>
        <li>
          <Trans
            i18nKey="fundraisingClub:facts_5"
            components={{
              a: (
                <a
                  href="https://www.begambleaware.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'inline-block', color: '#3091DB' }}
                >
                  https://www.begambleaware.org
                </a>
              ),
            }}
          />
        </li>
      </Typography>
    </Cushion>
  </>
);

ImportantFacts.propTypes = {};

export default ImportantFacts;
